import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-687 (4.2 date of birth).
export const DateOfBirthScreen = () => (
  <StubScreen id="date-of-birth" heading="Ihr Geburtsdatum" />
);
